import React from "react";
import { connect } from "react-redux";
import {  Card, Col, Row } from 'react-bootstrap';
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

import Display from "./display";

class Calendar extends React.Component {
    render() {
        return (
            <>
                <Row>
                    <Col xs="12">
                        <Display client={this.props.client} onSelect={this.props.onSelect} updated={this.props.updated} onCreate={this.props.onCreate} />
                    </Col>
                </Row>
            </>
        )
    }
}

Calendar.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
    });
};

export default connect(mapStateToProps)(Calendar);
